import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  IconButton,
  CardActions,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { getDocumentosAprobadosPorExpediente } from "../services/expediente.service";
import { obtenerDocumento } from "../services/uploadFile.service";
import { COLORS } from "../config/theme";

const DocumentosAprobados = ({ idExpediente }) => {
  const [documentos, setDocumentos] = useState([]);

  useEffect(() => {
    const fetchDocumentos = async () => {
      try {
        const result = await getDocumentosAprobadosPorExpediente(idExpediente);
        if (Array.isArray(result.data)) {
          setDocumentos(result.data);
        } else {
          setDocumentos([]);
        }
      } catch (error) {
        console.error("Error al obtener documentos:", error);
      }
    };

    fetchDocumentos();
  }, [idExpediente]);

  const abrirDocumento = async (key) => {
    try {
      const response = await obtenerDocumento(key);

      if (response) {
        const signedUrl = response.url;
        const resultURL = signedUrl.split("?");

        window.open(resultURL[0], "_blank");
      } else {
        console.error("Error obteniendo documento");
        // TODO: Mostrar mensaje en pantalla
      }
    } catch (error) {
      console.error("Failed to get signed URL", error);
    }
  };

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      {documentos.map((documento, index) => (
        <Card
          key={index}
          style={{
            width: "300px",
            backgroundColor: COLORS.LIGHT,
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={() => abrirDocumento(documento.url)}
        >
          <CardContent>
            <Typography variant="h6" component="div">
              {documento.nombre}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Creado {new Date(documento.fecha_alta).toLocaleDateString()}
            </Typography>
          </CardContent>
          <CardActions style={{ justifyContent: "center" }}>
            <IconButton color="primary">
              <DownloadIcon />
            </IconButton>
          </CardActions>
        </Card>
      ))}
    </div>
  );
};

export default DocumentosAprobados;
